import baseYMLog from '@actr/logger/src/logs/ym/base';

const aviaYMLogger = baseYMLog.extend('seo_avia');

export default aviaYMLogger;
